export default __webpack_public_path__ + "static/GT-Super-Display-Super-Italic-bf2e352f8691837b1f502583fbc0168d.woff";